import { Box } from '@mui/system';
import Details from '../Details/Details';
import SkeletonWrapper from '../Skeletons/SkeletonWrapper';
import { ICardStepContainer } from './type';

const CardStepContainer = (props: ICardStepContainer) => {
  const { detailsProps, isLoading, skeletonLines } = props;
  return (
    <>
      <Box
        display='flex'
        justifyContent='flex-start'
        gap={15}>
        <Box sx={{width: 'fit-content'}}>
          <SkeletonWrapper
            loading={isLoading}
            skeletonLines={skeletonLines || detailsProps.rows?.length}
          >
            <Details
              {...detailsProps}
            />
          </SkeletonWrapper>
        </Box>
      </Box>
    </>
  );
};

export default CardStepContainer;